// How the Vacation Planner pages write hours and dates. Shared by the list of
// saved plans and the planner itself so the two say things the same way.

import { toStartOfDay } from './payPeriods';

export const formatHours = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  return n.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

// "8 hrs", "1 hr", "0.25 hrs".
export const hrs = (value) => `${formatHours(value)} hr${Number(value) === 1 ? '' : 's'}`;

export const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;

// "Wed, Oct 14".
export const formatShortDate = (iso) => {
  const d = toStartOfDay(iso);
  if (!d) return '';
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
};

// "Oct 30 to Nov 2, 2026" - a saved plan's default name, and how the list
// shows its dates.
export const formatTripRange = (startIso, endIso) => {
  const start = toStartOfDay(startIso);
  const end = toStartOfDay(endIso);
  if (!start || !end) return '';
  const short = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  if (startIso === endIso) return `${short(start)}, ${start.getFullYear()}`;
  return start.getFullYear() === end.getFullYear()
    ? `${short(start)} to ${short(end)}, ${end.getFullYear()}`
    : `${short(start)}, ${start.getFullYear()} to ${short(end)}, ${end.getFullYear()}`;
};

// When a plan was saved: "Oct 15, 2026".
export const formatSavedAt = (value) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
